<app-button
  variant="secondary"
  color="amarante"
  size="small"
  [addLabel]="false"
  [addIconLeft]="true"
  [state]="isOpen() ? 'pressed' : 'default'"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (clicked)="toggleOpen()"
  [attr.title]="panelTitle() | translate">
  <img slot="icon-left" [src]="iconSrc()" alt="" />
</app-button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
  [cdkConnectedOverlayPositions]="positions">

  <div class="bl-panel">
    <div class="bl-panel-header">
      <label class="bl-select-all">
        <input
          #selectAllCheckbox
          type="checkbox"
          [checked]="isAllSelected()"
          (change)="toggleAll()"
        />
        {{ panelTitle() | translate }}
      </label>
      <button class="bl-close-btn" (click)="close()">&#x2715;</button>
    </div>
    <ul class="bl-list">
      @for (item of items(); track item.key) {
        <li>
          <label>
            <input
              type="checkbox"
              [checked]="isVisible(item.key)"
              (change)="toggle(item.key)"
            />
            {{ item.label | translate }}
          </label>
        </li>
      }
    </ul>
  </div>

</ng-template>
